import { DARK_SCHEME_QUERY } from './constants';
import { useMediaQuery } from './useMediaQuery';

/** Whether the OS asks for a dark appearance, kept live while the app is open. */
export const usePrefersDark = () => useMediaQuery(DARK_SCHEME_QUERY);
